import 'bootstrap';
import './sass/styles.scss';
import('./assets/images/arpeus-logo.webp');
import('./assets/images/owlet-dream-socks.webp');
import('./assets/images/luis-kovalsky.webp');
import('./assets/images/sergio-leverato.webp');

const copySpan = document.querySelector('#current-year');
copySpan.innerHTML = new Date().getFullYear();
